<div class="tab-content" data-cropper-variant="{{cropperName}}" id="{{cropperName}}-cropper-content">
  <div class="croptions">
    <span class="crop-select">
      <span class="crop-title">Cropping:</span>
      {{#if variant.type}}
        {{sp_select_tag "" dataBehaviour="select-cropper-ratio" choices=cropperItems selected=variant.type required=true includeBlank=false}}
      {{else}}
        {{sp_select_tag "" dataBehaviour="select-cropper-ratio" choices=cropperItems selected="none" required=true includeBlank=false}}
      {{/if}}
    </span>

    <section class="dropdown advanced-options">
      <span class="btn dropdown-button">
        {{{ icon 'configure '}}}
      </span>

      <nav class="dropdown-menu" data-close-menu="false">
        <div class="dropdown-content dropdown-action-panel">
          <label class="advanced-title">Advanced options</label>

          <div data-method="set-max-size">
            <label class="max-size-label">Max height</label>
            <input class="max-size-input" name="max_height" placeholder="Set the max height">
          </div>

          <div data-method="set-max-size">
            <label class="max-size-label">Max width</label>
            <input class="max-size-input" name="max_width" placeholder="Set the max width">
          </div>
        </div>
      </nav>
    </section>
  </div>

  <img class="preview-img" src="{{imageUrl}}" data-behaviour="cropper" />
  <div id="zoom-slider" class="cr-slider-wrap">
    <input data-method=zoom class="cr-slider" type="range" step="0.001" aria-label="zoom" min=".3555" max="3.000" aria-valuenow=".3555">
    <div class="zoom-fill"></div>
    <div class="zoom-track"></div>
    <div class="zoom-thumb"></div>
    {{{ icon 'image '}}}
    {{{ icon 'image '}}}
  </div>
</div>
